"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var lodash_get_1 = __importDefault(require("lodash.get"));
var React = __importStar(require("react"));
var _1 = require(".");
var CreditCardImage_1 = __importDefault(require("./CreditCardImage"));
var VerifyPaymentCardStrings_1 = __importDefault(require("./VerifyPaymentCardStrings"));
var VerifyCardTemplate = function (_a) {
    var hideExpiryDetails = _a.hideExpiryDetails;
    var paymentCard = React.useContext(_1.VerifyPaymentCardContext).paymentCard;
    var cardType = lodash_get_1["default"](paymentCard, 'type') || '';
    var last4 = lodash_get_1["default"](paymentCard, 'last4', null);
    var expMonth = lodash_get_1["default"](paymentCard, 'expMonth', null);
    var expYear = lodash_get_1["default"](paymentCard, 'expYear', null);
    var expiryDisplay = hideExpiryDetails ? '' : ", " + expMonth + "/" + expYear;
    return (React.createElement(React.Fragment, null, last4 && expMonth && expYear && (React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.XxxSmall },
        React.createElement(design_language_1.Text, { textAlign: design_language_1.Text.TextAlignments.Center }, VerifyPaymentCardStrings_1["default"].paymentCard()),
        React.createElement(design_language_1.InlineChildren, { alignItems: design_language_1.InlineChildren.Alignment.Center, justifyContent: design_language_1.InlineChildren.Justification.Center, size: design_language_1.InlineChildren.Sizes.XxSmall },
            cardType && React.createElement(CreditCardImage_1["default"], { cardName: cardType.toLowerCase() }),
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center },
                "....",
                last4,
                expiryDisplay))))));
};
exports["default"] = VerifyCardTemplate;
